import {Component, OnInit} from '@angular/core';
import {UtilitiesService} from "../../helpers/utilities.service";

export interface Personnel {
    name: string;
    func: string;
    img: string;
}

@Component({
    selector: 'app-organisers',
    templateUrl: './organisers.component.html',
    styleUrls: ['./organisers.component.scss']
})
export class OrganisersComponent implements OnInit {

    mainOrganizers: Personnel[] = [
        {
            name: 'Симона Крстева',
            func: '',
            img: ''
        },
        {
            name: 'Кристина Запрова',
            func: '',
            img: ''
        }
    ];

    coreTeam: Personnel[] = [
        {
            name: 'Јована Ѓоргиеска',
            func: 'Одговорна за контактирање на компании',
            img: ''
        },
        {
            name: 'Леонтина Пауновска',
            func: 'Одговорна за односи со компании',
            img: ''
        },        
        {
            name: 'Станислав Пачуков',
            func: 'Одговорен за односи со компании',
            img: ''
        },        
        {
            name: 'Ермал Баки',
            func: 'Одговорен за информациски технологии',
            img: ''
        },
        {
            name: 'Ана Ѓорѓиевска',
            func: 'Одговорна за односи со јавност',
            img: ''
        },
        {
            name: 'Стефче Китановски',
            func: 'Одговорен за дизајн',
            img: ''
        },
        {
            name: 'Емилија Илова',
            func: 'Одговорна за логистика',
            img: ''
        },        
        
        

    ];
    board: Personnel[] = [
        {
            name: 'Евгенија Попчановска',
            func: 'Претседател',
            img: ''
        },
        {
            name: 'Раде Мицов',
            func: 'Потпретседател',
            img: ''
        },
        {
            name: 'Камелија Матеска',
            func: 'Секретар',
            img: ''
        },
        {
            name: 'Бојана Цилевска',
            func: 'Координатор за човечки ресурси',
            img: ''
        },
        {
            name: 'Ангела Крстановска',
            func: 'Координатор за односи со компании',
            img: ''
        },
        {
            name: 'Илија Крстески',
            func: 'Координатор за информациски технологии',
            img: ''
        },
        
    ];

    constructor(private utils: UtilitiesService) {
        this.mainOrganizers.forEach(element => {
            element.img = this.getPersonelImage(element.name);
        });

        this.coreTeam.forEach(element => {
            element.img = this.getPersonelImage(element.name);
        });

        this.board.forEach(element => {
            element.img = this.getPersonelImage(element.name);
        });
    }

    ngOnInit(): void {
    }

    getPersonelImage(name: string): string {
        name = name.split(' ').join('_');
        return this.utils.getStaticImageApi() + '/organisers/' + name + '.webp';
    }
}
